/*
 * FloatingAssistant — the ✨ Assistant on pages that don't use the AquaStar AdminLayout topbar
 * (the /platform/* Nexus admin pages, which bring their own shared layout). A fixed button at the
 * bottom-right opens the same AssistantDrawer.
 */

import { useState } from 'react';
import AssistantDrawer from './AssistantDrawer';

export default function FloatingAssistant() {
  const [open, setOpen] = useState(false);
  return (
    <>
      {!open && (
        <button
          type="button"
          className="btn shadow d-inline-flex align-items-center gap-2"
          onClick={() => setOpen(true)}
          data-testid="open-assistant-floating"
          title="Ask the fleet assistant"
          style={{
            position: 'fixed',
            right: 20,
            bottom: 20,
            zIndex: 1040,
            borderRadius: 999,
            padding: '0.55rem 1rem',
            background: 'var(--aqua-navy, #101c42)',
            color: '#fff',
            border: '1px solid rgba(0, 191, 216, 0.6)',
          }}
        >
          ✨ <span className="d-none d-sm-inline">Assistant</span>
        </button>
      )}
      <AssistantDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
